import { PromotionMailTemplate } from './PromotionMailTemplate';

export { mailTemplateFormFromApi } from './form';
export { useDefaultLanguage, LanguageTabs, useLanguageState } from './LanguageTabs';

export default PromotionMailTemplate;
